import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import ComingSoonPage from './pages/ComingSoonPage';
import RegisterPage from './pages/RegisterPage';
import LoginPage from './pages/LoginPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import VerifyEmailPage from './pages/VerifyEmailPage';
import { isRegistrationLive } from './utils/registrationLive';

// The register/login front-door. `/register` (uid-001-3b) and `/login`
// (uid-001-login-frontdoor-ui) are the hosted pages every DAO/FOS property
// redirects to; `/login` returns a JWT + a cross-domain handoff code.
//
// The `/` root route is gated on the VITE_REGISTRATION_LIVE build flag:
//  - flag live (staging): `/` leads INTO the workflow (→ /register, preserving
//    any returnUrl query so a cross-origin caller's deep-link survives). This
//    is what makes the full register→login flow reachable end-to-end without
//    dead-ending on the placeholder.
//  - flag unset/false (prod default): `/` renders ComingSoonPage — the public
//    front door is not yet launched.
// The `*` catch-all stays ComingSoonPage either way (genuine unknown paths).
function FrontDoor() {
  const location = useLocation();
  if (isRegistrationLive()) {
    // Preserve the query string (e.g. a cross-origin returnUrl) into the
    // workflow. `replace` so the placeholder-vs-workflow root isn't a back-button
    // trap. Same-app relative nav — the open-redirect gate still runs inside
    // RegisterPage when it resolves the returnUrl.
    return <Navigate to={{ pathname: '/register', search: location.search }} replace />;
  }
  return <ComingSoonPage />;
}

export default function App() {
  return (
    <Routes>
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/login" element={<LoginPage />} />
      {/* bl-777: forgot-password / reset-password live on the front-door (the
          reset link identity-service emails points here). */}
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      {/* bl-813: the email-verification link identity-service emails points here
          (`{zone}/verify-email?token=…`). A REAL route on BOTH zones so the link
          no longer falls through to the `*` ComingSoonPage catch-all. */}
      <Route path="/verify-email" element={<VerifyEmailPage />} />
      <Route path="/" element={<FrontDoor />} />
      <Route path="*" element={<ComingSoonPage />} />
    </Routes>
  );
}
